/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { View, type StyleProp, type ViewStyle } from 'react-native';
import { surfaceCardStyles as styles } from './surfaceCards.styles';

export type DenseListCardAccentTone = 'neutral' | 'amber';

type Props = {
  children: React.ReactNode;
  bodyStyle?: StyleProp<ViewStyle>;
  wrapStyle?: StyleProp<ViewStyle>;
  accentTone?: DenseListCardAccentTone;
  /** Barra lateral semántica (señales, alertas); tiene prioridad sobre accentTone. */
  accentBarColor?: string;
};

/** Listado / bloque de datos: barra lateral + cuerpo (neutro por defecto; ámbar solo si se pide explícitamente). */
export function DenseListCard({
  children,
  bodyStyle,
  wrapStyle,
  accentTone = 'neutral',
  accentBarColor,
}: Props) {
  const accentStyle = accentBarColor
    ? [styles.denseListAccentNeutral, { backgroundColor: accentBarColor }]
    : accentTone === 'amber'
      ? styles.denseListAccentAmber
      : styles.denseListAccentNeutral;

  return (
    <View style={[styles.denseListWrap, wrapStyle]}>
      <View style={accentStyle} pointerEvents="none" accessibilityElementsHidden />
      <View style={[styles.denseListBody, bodyStyle]}>{children}</View>
    </View>
  );
}
